/**
 * This component renders the schedule tab for a club page
 */
import React from "react";

import Schedule from "../core/Schedule";

const ClubSchedule = ({ clubData }) => {
  // Define club gradient based on data
  // const gradientStyle = {
  //   background: `linear-gradient(to right, ${clubData.primary_color}, ${clubData.secondary_color})`,
  // };

  // Parse team data
  const parseTeams = (data) => {
    const teamsArray = [];
    data.teams.map((team) => {
      if (team.rank > 0) teamsArray.push(team);
    });
    return teamsArray;
  }

  return (
    <Schedule 
      mode="club" 
      teams={parseTeams(clubData)}
      clubs={[]}
      id={clubData.id}
      seasons={clubData.games_seasons}
    />
  );
}
export default ClubSchedule;